module.exports = __webpack_public_path__ + "static/vajra_safahr-96bf094d2f6a3ea6c7985e0cfb0df216.png";